import script from "./PatientComments.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientComments.vue?vue&type=script&setup=true&lang=js"

import "./PatientComments.vue?vue&type=style&index=0&id=7c368c80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c368c80"]])

export default __exports__